export default {
  stats: [
    { value: "200+", label: "Trucks Launched" },
    { value: "34", label: "OC Cities Covered" },
    { value: "98%", label: "Permit Approval Rate" },
    { value: "10 Wks", label: "Avg. Time to Launch" },
  ],
  headingTag: "Simple. Proven. Effective.",
  title1: "How We Get You",
  title2: "On the Road",
  subtitle:
    "From your first call to your first day of service, we handle every step of the OC food truck launch process so you can focus on the food.",
  steps: [
    {
      title: "Book a Session",
      description:
        "Fill out our intake form and schedule a session with one of our OC food truck specialists. We review your concept, goals, and timeline before we even get started.",
    },
    {
      title: "Get Your Custom Roadmap",
      description:
        "We build a personalized action plan covering every permit, license, and compliance requirement specific to your city in Orange County — no guesswork.",
    },
    {
      title: "We Handle the Heavy Lifting",
      description:
        "Our team guides your permit filings, commissary agreements, health inspections, and vehicle requirements step by step so nothing slips through the cracks.",
    },
    {
      title: "Roll Out & Start Earning",
      description:
        "With all approvals secured, you hit the streets with full confidence. We stay on call for renewals, expansions, and any new city permits you need down the road.",
    },
  ],
  ctaText: "Ready to start the process?",
  bookSession: "Book a Session",
};